import axios from "src/lib/axios";

/**
 * 
 * @param {ObjectId} id 
 * @param {Object} data
 * @param {String} data.status - on, off
 * @returns 
 */
export const changeDealStatus = (id, data) =>
  axios.patch(`/exclusive/status/${id}`, data);

export const findAllXclusiveDeal = () =>
  axios.get(`/exclusive/all-xclusive-data`);

/**
 *
 * @param {ObjectId} id
 * @param {Object} data
 * @param {File | String} data.background
 * @param {String} data.splash_screen_desktop
 * @param {File | String} data.splash_screen_tablet
 * @param {File | String} data.splash_screen_mobile
 * @param {File | String} data.meta_img - meta_tag img
 * @param {Object} data.meta_tag
 * @param {String} data.meta_tag.title
 * @param {String} data.meta_tag.desc
 * @param {String} data.meta_tag.keywords
 * @param {Boolean} data.status_deal
 * @returns
 */
export const updateDealLanding = (data) =>
  axios.patch(`/exclusive/landing-data`, data, {
    headers: {
      "Content-Type": "multipart/form-data", // do not forget this
    },
  });

/**
 * 
 * @param {ObjectId} group_id
 * @returns 
 */
export const searchDealProduct = ({ group_id = null }) =>
  axios.get(`/exclusive/search-product-deal-group`, {
    params: {
      group_id,
    }
  });

/**
 *
 * @param {Object} data
 * @param {File} data.banner
 * @returns
 */
export const addBanner = (data) =>
  axios.post(`/exclusive/banner`, data, {
    headers: {
      "Content-Type": "multipart/form-data", // do not forget this
    },
  });

/**
 * @param {Object[]} data - new rearranged banner positions
 * @returns
 */
export const moveDealBannerPosition = (data) =>
  axios.patch(`/exclusive/move-banner`, data);

/**
 *
 * @param {ObjectId} id
 * @returns
 */
export const deleteBanner = (id) =>
  axios.delete(`/exclusive/banner`, {
    data: { _id: id },
  });

/**
 * 
 * @param {ObjectId} id
 * @returns 
 */
export const findOneDealGroup = (id) =>
  axios.get(`/exclusive/deal-group-data/${id}`);

/**
 * 
 * @param {ObjectId} id
 * @param {Object} options - query options
 * @param {Number} options.page - Page number
 * @param {Number} options.page_size - Number of items per page
 * @param {String} options.sortBy - Field to sort by
 * @param {String} options.sortOrder - Sort order
 * @returns 
 */
export const findAllProductGroup = (id, options) =>
  axios.get(`/exclusive/all-product-deal-group/${id}`, {
    params: { ...options },
  });


/**
 *
 * @param {Object} data
 * @param {String} data.name
 * @param {File} data.icon
 * @param {File} data.icon_hover
 * @param {File} data.banner
 * @param {File} data.img - meta_tag img
 * @param {Number} data.position
 * @param {Object} data.meta_tag
 * @param {String} data.meta_tag.title
 * @param {String} data.meta_tag.desc
 * @param {String} data.meta_tag.keywords
 * @param {Object[]} data.product_choice_deals
 * @returns
 */
export const addDealGroup = (data) =>
  axios.post(`/exclusive/deal-group`, data, {
    headers: {
      "Content-Type": "multipart/form-data", // do not forget this
    },
  });

/**
 *
 * @param {Object} data
 * @param {ObjectId} data._id
 * @param {String} data.name
 * @param {File | String} data.icon
 * @param {File | String} data.icon_hover
 * @param {File | String} data.banner
 * @param {File | String} data.img - meta_tag img
 * @param {Number} data.position
 * @param {Object} data.meta_tag
 * @param {String} data.meta_tag.title
 * @param {String} data.meta_tag.desc
 * @param {String} data.meta_tag.keywords
 * @param {Object[]} data.product_choice_deals
 * @returns
 */
export const updateDealGroup = (data) =>
  axios.patch(`/exclusive/deal-group`, data);

/**
 *
 * @param {ObjectId} id
 * @returns
 */
export const deleteGroup = (id) => axios.delete(`/exclusive/deal-group/${id}`);

/**
 *
 * @param {ObjectId} group_id dealGroup _id
 * @param {ObjectId} pc_id product_choice._id
 * @returns
 */
export const deleteProductInGroup = (group_id, pc_id) => axios.delete(`/exclusive/product-deal-group/${group_id}`, {
  data: { pc_id: pc_id },
});

/**
 * @param {Object[]} data - new rearranged group positions
 * @returns
 */
export const moveDealGroupPosition = (data) =>
  axios.patch(`/exclusive/move-group`, data);

/**
 *
 * @returns
 */
export const getSellerNotDeal = () => axios.get(`/exclusive/seller-other`);

/**
 * @param {Object[]} data - new rearranged seller positions
 * @returns
 */
export const moveDealSellerPosition = (data) =>
  axios.patch(`/exclusive/move-seller`, data);

/**
 *
 * @param {Object} data
 * @param {ObjectId} data.seller_id - seller id
 * @returns
 */
export const addSeller = (data) => axios.post(`/exclusive/seller`, data);

/**
 *
 * @param {ObjectId} id
 * @returns
 */
export const deleteSeller = (id) =>
  axios.delete(`/exclusive/seller`, {
    data: { seller_id: id },
  });

/**
 *
 * @param {Object} data
 * @param {ObjectId} data._id - dealGroup _id
 * @param {{product_choice_deal: ObjectId; price: Number; special_price: Number}[]} data.product_choice_deals
 * @returns
 */
export const addProductGroup = (data) =>
  axios.patch(`/exclusive/add-product-deal-group`, data);


/**
 *
 * @param {Object} data
 * @param {ObjectId} data._id - dealGroup _id
 * @param {{product_choice_deal: ObjectId; price: Number; special_price: Number}[]} data.product_choice_deals
 * @returns
 */
export const updateProductGroup = (data) =>
  axios.patch(`/exclusive/product-deal-group`, data);
